import React, { ElementType, ReactNode } from "react";
import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import BoxComponent from "../Box/BoxComponent";

interface CarouselProps {
    children: ReactNode
    sx?: SxProps<Theme>;
    component: ElementType;
}

const CardComponent = (props: CarouselProps) => {
    return <BoxComponent
        component={props.component}
        sx={props.sx}
    >
        {props.children}
    </BoxComponent>
}

export default CardComponent;